module.exports = __webpack_public_path__ + "Roboto-Light.8e0860f3581b197e9fa4.woff2";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Light.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Light.woff2
// module chunks = 34